import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useRecoilValue } from "recoil";
import { roleModules } from "src/atoms/roleModules.atom";
import { urlPermission } from "src/utils/common.utils";

export const useUrls = () => {
  const userModules = useRecoilValue(roleModules);
  const [allowedUrls, setAllowedUrls] = useState<(string | undefined)[]>();
  const { pathname } = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    const res = urlPermission(userModules, pathname);
    setAllowedUrls(res?.allowedUrls);
    if (!res?.permission.length) {
      navigate("/admin/dashboard", { replace: true });
    }
  }, [pathname]);

  return {
    allowedUrls,
    userModules,
  };
};
